"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = theme => ({
  upload: {
    position: 'relative',
    '&.custom': {
      display: 'inline-flex',
      alignItems: 'self-end',
      justifyContent: 'center',
      flexDirection: 'column',
      backgroundColor: 'inherit',
      '& img': {
        opacity: '0.5'
      },
      '&.error': {
        backgroundColor: 'inherit'
      },
      '& $helperText': {
        position: 'inherit',
        top: 0,
        left: 0
      }
    },
    '&.hidden': {
      display: 'none'
    },
    '&.disabled': {
      opacity: theme.disabledOpacity,
      cursor: 'default',
      '& input': {
        cursor: 'default'
      }
    },
    '&.error': {
      color: theme.errorColor,
      '& $iconUpload .fill': {
        fill: theme.errorColor
      },
      '& $loadBtn': {
        borderColor: theme.errorColor
      },
      '& $helperText': {
        color: theme.errorColor,
        padding: 4
      }
    },
    '&.active': {
      '& $loadBtn': {
        backgroundColor: theme.upload.active.backgroundColor,
        borderColor: theme.upload.active.borderColor
      }
    }
  },
  loadBtn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 64,
    backgroundColor: theme.upload.backgroundColor,
    borderRadius: theme.upload.borderRadius,
    border: `1px dashed ${theme.upload.borderColor}`
  },
  filesList: {
    padding: 16
  },
  filesListPortal: {},
  iconUpload: {
    transform: 'rotate(-90deg)',
    marginRight: 11,
    '& .fill': {
      fill: theme.upload.iconUploadColor
    }
  },
  browseLinkBox: {
    overflow: 'hidden',
    position: 'relative',
    '&:hover': {
      '& $browseLink': {
        'text-decoration': 'underline'
      }
    },
    '& input': {
      opacity: 0,
      position: 'absolute',
      right: 0,
      top: 0,
      cursor: 'pointer'
    }
  },
  browseLink: {
    color: theme.upload.browseLinkColor
  },
  helperText: {
    marginTop: 4
  },
  customBox: {
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& input': {
      opacity: 0,
      position: 'absolute',
      right: 0,
      top: 0,
      cursor: 'pointer',
      height: '100%',
      'z-index': 3
    }
  },
  iconCamera: {
    position: 'absolute',
    zIndex: 2
  },
  filesLabel: {
    padding: '0 12px 12px 12px'
  },
  portal: {
    clear: 'both',
    overflow: 'auto'
  }
});

exports.default = _default;